export default __webpack_public_path__ + "static/media/bedKlein.0bd59fd2.jpg";